/* eslint-env browser */
/* eslint-disable react/jsx-no-target-blank */

import React from 'react';
import PureComponent from 'react-pure-render/component';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { replace } from 'redux-router';
import { login, logout, initLoginState, setHeader, removeErrorMessage, validateLoginState } from 'actions';
import has from 'lodash/has';

import Loading from 'components/common/Loading';

class LoginPage extends PureComponent {
  componentWillMount() {
    this.props.setHeader(false);
    this.handleLogin = this.handleLogin.bind(this);

    // Check for a saved session and validate it's still valid
    const authToken = window.persistStore.getItem('auth_token');
    const userId = window.persistStore.getItem('user_id');
    if (authToken && userId) {
      this.props.validateLoginState(authToken, userId, () => {
        this.props.replace('/calendar');
      }, () => {
        this.props.logout();
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.auth.auth_token > '') {
      this.props.removeErrorMessage();
      nextProps.replace('/calendar');
    }
  }

  handleLogin(event) {
    event.preventDefault();

    this.props.login(
      this.refs.email.value,
      this.refs.password.value,
      this.refs.remember_me.checked
    );
    return;
  }

  render() {
    if (this.props.isLoading) {
      return (
        <Loading withWrapper />
      );
    }

    const { auth } = this.props;
    const email = window.persistStore.getItem('email') || auth.email;
    let rememberMe = window.persistStore.getItem('rememberMe') === 'true' || auth.rememberMe;
    if (window.persistStore.getItem('rememberMe') === 'false') {
      rememberMe = false;
    }

    var login_twitter_href = window.DESKTOP_URL + '?type=login&action=twitter_redirect&ref_mobile=t';
    var login_facebook_href = window.DESKTOP_URL + '?type=login&action=facebook_redirect&ref_mobile=t';
    var login_google_href = window.DESKTOP_URL + '?type=login&action=google_redirect&ref_mobile=t';
    var login_microsoft_href = window.DESKTOP_URL + '?type=login&action=windows_live_redirect&ref_mobile=t';

    if(window.SUBDOMAIN.length > 0)
    {
        login_twitter_href += '&ref_subdomain=' + window.SUBDOMAIN;
        login_facebook_href += '&ref_subdomain=' + window.SUBDOMAIN;
        login_google_href += '&ref_subdomain=' + window.SUBDOMAIN;
        login_microsoft_href += '&ref_subdomain=' + window.SUBDOMAIN;
    }

    let twitterEnabled = false;
    let facebookEnabled = false;
    let googleEnabled = false;
    let microsoftEnabled = false;

    if (has(window.CONFIG, 'enable_twitter_login')) {
      if (window.CONFIG.enable_twitter_login === '1') {
        twitterEnabled = true;
      }
    }

    if (has(window.CONFIG, 'enable_facebook')) {
      if (window.CONFIG.enable_facebook === '1') {
        facebookEnabled = true;
      }
    }

    if (has(window.CONFIG, 'enable_google_login')) {
      if (window.CONFIG.enable_google_login === '1') {
        googleEnabled = true;
      }
    }

    if (has(window.CONFIG, 'enable_windows_live_id')) {
      if (window.CONFIG.enable_windows_live_id === '1') {
        microsoftEnabled = true;
      }
    }

    let tandemLogo = window.EXPANDED_APP_ROOT + 'img/tandem-logo-gray@2x.png';

    if (has(window.CONFIG, 'ui')) {
      if (window.CONFIG.ui === 'card' || window.CONFIG.ui === 'shore2') {
        tandemLogo = window.EXPANDED_APP_ROOT + 'img/tandem-logo2-gray@2x.png';
      }
    }

    return (
      <section className="login-page">
        <div className="card">
          <img src={tandemLogo} className="loginLogo" alt="logo" />

          <form onSubmit={this.handleLogin}>
            <p>
              <input
                type="email"
                ref="email"
                placeholder="Email"
                defaultValue={email}
              />
            </p>

            <p>
              <input
                type="password"
                ref="password"
                placeholder="Password"
              />
            </p>

            <p className="rememberMe" />

            <p className="loginBottomActions">
              <input
                type="checkbox"
                ref="remember_me"
                defaultChecked={rememberMe}
              /> Remember Me

              <a className="pull-right" target="_blank" href="https://tandem.co/forgot.php">Reset my password</a>
            </p>

            <button className="primary block" onClick={this.handleLogin}>Login with Tandem</button>
          </form>

          <div className="loginOtherTypes">
            <p>or</p>
            {twitterEnabled && (<a href={`${login_twitter_href}`}><button className="primary block">Login with Twitter</button></a>)}
            {facebookEnabled && (<a href={`${login_facebook_href}`}><button className="primary block">Login with Facebook</button></a>)}
            {googleEnabled && (<a href={`${login_google_href}`}><button className="primary block">Login with Google</button></a>)}
            {microsoftEnabled && (<a href={`${login_microsoft_href}`}><button className="primary block">Login with Microsoft</button></a>)}
          </div>

          <div className="loginSignUp">
            <p>New to Tandem?</p>
            <Link to="/signup"><button className="block">Sign Up</button></Link>
          </div>

        </div>
      </section>
    );
  }
}

function mapStateToProps(state) {
  const { auth } = state;

  return {
    auth,
    isLoading: auth.isLoading,
  };
}

export default connect(mapStateToProps, {
  login,
  logout,
  setHeader,
  initLoginState,
  replace,
  removeErrorMessage,
  validateLoginState,
})(LoginPage);



// WEBPACK FOOTER //
// ./src/app/containers/LoginPage.js